import React from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { bpfAPI, TemplatesList, TemplatesResponse, GetTemplatesVariables } from 'modules/stages';

import { accountSelectors } from '../../redux/accountReducer';

export const ListOfTemplates = () => {
  const accountId = useSelector(accountSelectors.accountId);

  const { data } = useQuery<TemplatesResponse, GetTemplatesVariables>(bpfAPI.fetchTemplates, {
    variables: { input: { accountId } },
    fetchPolicy: 'cache-and-network',
  });

  return <TemplatesList templates={data?.bpf?.templates ?? []} />;
};
